import React from 'react';
import FlexibleTable from '@/stories/Components/FlexibleTable/FlexibleTable';
import { useTranslations } from 'use-intl';
import { toTranslationKey } from '@/utils/translations';
import {
	CreditBureauPerson,
	CreditBureauMaritalStatus,
	ResidenceType
} from '@/graphql/__generated__/onboarding';
import { getMaritalStatusText, getResidenceTypeText } from './mapUtils';
import ExpandableTable from './ExpandableTable';

interface NameProps {
	name: CreditBureauPerson;
}

const Name: React.FC<NameProps> = ({ name }) => {
	const t = useTranslations('CreditBureau');
	if (!name) return null;

	// Create a new object with translated keys and mapped values
	const translatedData = Object.entries(name)
		.filter(([key]) => key !== '__typename')
		.reduce(
			(acc, [key, value]) => {
				const translatedKey = t(toTranslationKey(key));

				// Map special fields
				if (key === 'maritalStatus' && value) {
					acc[translatedKey] = getMaritalStatusText(value as CreditBureauMaritalStatus, t);
				} else if (key === 'residenceType' && value) {
					acc[translatedKey] = getResidenceTypeText(value as ResidenceType, t);
				} else {
					acc[translatedKey] = value;
				}

				return acc;
			},
			{} as Record<string, any>
		);

	return (
		<ExpandableTable title={t('Name')}>
			<div className="max-w-4xl">
				<FlexibleTable flipped data={translatedData} />
			</div>
		</ExpandableTable>
	);
};

export default Name;
